// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"ca61ce74","7992":"704ae499"}[chunkId] + ".chunk.css";
};